import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import GlobalContext from '../contexts/global.js';
import { fillPageHeadMeta } from '../hooks/headAmender.js';
import UserMenu from './UserMenu.js';

import '../styles/header.css';

const Header = () => {
    const { globalContext } = useContext(GlobalContext);
    const navigate = useNavigate();
    const searchInputRef = useRef(null);

    const [searchContent, setSearchContent] = useState("");
    const [searchOpen, setSearchOpen] = useState(false);

    useEffect(() => {
        searchOpen && searchInputRef.current?.focus();
    }, [searchOpen]);

    fillPageHeadMeta({
        name: globalContext?.siteConfig?.siteName,
        description: globalContext?.siteConfig?.siteDescription,
        owner: globalContext?.siteConfig?.siteOwner
    });

    return (
        <div className="header">
            <div className="container">
                <div className="content">
                    <div className="brand">
                        <Link className="logo" to="/" tabIndex="-1">
                            <img
                                alt="PwC"
                                src={`${process.env.PUBLIC_URL}/assets/logos/pwclogo.svg`}
                                className="img-responsive"
                            />
                        </Link>
                        { globalContext?.siteConfig?.siteName && (
                            <>
                                <div className="divider"></div>
                                <Link className="site-name" to="/">{ globalContext?.siteConfig?.siteName }</Link>
                            </>
                        )}
                    </div>

                    <div className="tools">
                        <div className={ `tool search ${ searchOpen ? "open" : "" }` }>
                            <button
                                type="button"
                                className="tool-button"
                                aria-label="Search"
                                aria-expanded={searchOpen}
                                onClick={ () => setSearchOpen(open => !open) }
                            >
                                <span
                                    className="icon flipped"
                                    style={{
                                        maskImage: `url(${process.env.PUBLIC_URL}/assets/icons/search.svg)`
                                    }}
                                />
                            </button>

                            <form
                                className="expand"
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    navigate(`/search/${searchContent}`);
                                }}
                            >
                                <input
                                    ref={searchInputRef}
                                    type="search"
                                    className="search-box"
                                    autoComplete="off"
                                    placeholder="Search"
                                    tabIndex={searchOpen ? 0 : -1}
                                    value={searchContent}
                                    onChange={(event) => setSearchContent(event.currentTarget.value)}
                                />
                            </form>
                        </div>

                        <UserMenu />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
